export const emptystate = {
  root: {
    gap: "{gap.24}",
  },
  image: {
    size: "180px",
  },
  text: {
    gap: "{gap.16}",
  },
  caption: {
    fontSize: "{typography.card.heading.font.size}",
    fontLeading: "{typography.card.heading.font.leading}",
    fontWeight: "{typography.card.heading.font.weight}",
  },
  description: {
    color: "{text.subtle-text}",
  },
};
